import { WorkspaceSelector } from "@drift/oneplatfront-components";
import { faCheckCircle, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "@onefront/react-sdk";
import { Typography } from "@vapor/react-extended";
import {
  Alert,
  AlertTitle,
  Card,
  Divider,
  Grid,
  IconButton,
  Snackbar,
  Stack,
} from "@vapor/react-material";
import { PageTitleProps } from "../types";

const PageTitle = ({
  open,
  handleClose,
  Slide,
  ws,
  workspaceId,
}: PageTitleProps) => {
  const { t } = useTranslation("DOCS");

  return (
    <Card
      sx={{
        marginTop: "16px",
        marginLeft: "16px",
        marginRight: "16px",
        // boxShadow: "inset 0px 16px hsl(199, 30%, 93%)",
      }}
    >
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        TransitionComponent={Slide}
      >
        <Alert
          variant="outlined"
          severity="success"
          icon={<FontAwesomeIcon icon={faCheckCircle} />}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
              style={{ color: "black", fontWeight: "bold" }}
            >
              <FontAwesomeIcon
                icon={faTimes}
                style={{ fontWeight: "bold", verticalAlign: "middle" }}
              />
            </IconButton>
          }
        >
          <AlertTitle>{t("download.success")}</AlertTitle>
        </Alert>
      </Snackbar>
      <Stack direction="column">
        <Grid container>
          <Grid item xs={4}>
            <div></div>
          </Grid>
          <Grid item xs={4}>
            <Stack
              direction="column"
              alignItems="center"
              justifyContent="space-evenly"
              minHeight="80px"
            >
              <Typography variant="titleSmall">{t("common.title")}</Typography>
              <Typography variant="caption">
                {t("document.subTitle") +
                  `${
                    ws
                      ? `: ${
                          [...ws?.companies, ...ws?.accountants].find(
                            (x) => x.id === workspaceId
                          )?.description
                        }`
                      : ""
                  }`}
              </Typography>
            </Stack>
          </Grid>
          <Grid item xs={4}>
            <Stack direction="row" justifyContent="flex-end">
              <WorkspaceSelector />
            </Stack>
          </Grid>
        </Grid>
        <Divider></Divider>
      </Stack>
    </Card>
  );
};

export default PageTitle;
